import type { ServerConfig } from '@attensi/frontend-server'

const config = {
  env: [
    'VITE_APP_API_BASE_URL',
    'VITE_APP_API_TOKEN',
    'VITE_APP_AUTH_URL',
    'VITE_APP_ENV',
    'VITE_APP_FAST_URL',
    'VITE_APP_FIESTA_URL',
    'VITE_APP_LOGIN_URL',
    'VITE_APP_PORTAL_URL',
    'VITE_APP_OPTIMIZER_URL',
    'VITE_APP_FLOWISE_AI_API_KEY',
    'VITE_APP_FLOWISE_URL',
  ],

  optionalEnv: [
    'VERCEL_GIT_COMMIT_SHA',
    'GIT_COMMIT_SHA',
    'VITE_APP_INSIGHTS_REACT_URL',
  ],

  envPrefix: 'VITE_APP_',

  publicRoot: 'dist',

  isImmutableFile: ({ dir }) => dir.endsWith('assets'),

  contentSecurityPolicy: {
    imgSrc: 'https:',
    scriptSrc: ['*.attensi.com', "'unsafe-eval'"],
    connectSrc: ['*.attensi.com', 'sentry.io', 'localhost:*'],
    frameSrc: '*',
    reportUri: 'https://attensi.report-uri.com/r/t/csp/reportOnly',
    reportOnly: true,
  },
} as const satisfies ServerConfig

export default config
